import { extend, localize } from 'vee-validate'
import {
  digits,
  email,
  required,
  max,
  max_value,
  min,
  min_value,
  numeric,
  double
} from 'vee-validate/dist/rules'
import es from 'vee-validate/dist/locale/es.json'

extend('required', required)
extend('email', email)
extend('digits', digits)
extend('max', max)
extend('max_value', max_value)
extend('min', min)
extend('min_value', min_value)
extend('numeric', numeric)
extend('double', double)
extend('date_format_ddmmyyyy', {
  validate: (value) => {
    if (value) {

      let indexWithSlash = [2, 5]
      let indexWithNumber = [0, 1, 3, 4, 6, 7, 8, 9]

      for (let i = 0; i < indexWithSlash.length; i++) {
        if (value[indexWithSlash[i]] !== '/') return false
      }
      for (let i = 0; i < indexWithNumber.length; i++) {
        if (isNaN(value[indexWithNumber[i]])) return false
      }

      let day = Number(value[0] + value[1])
      let month = Number(value[3] + value[4])
      let millenium = Number(value[6])
      if (day > 31) return false
      if (month > 12) return false
      if (millenium < 1 || millenium > 2) return false
      if (value.length !== 10) return false

      return true
    }
  },
  message: 'El formato de {_field_} no es válido'
})
extend('before_date', {
  validate(value, {date}) {
    if (value && date) {
      const dateBefore = new Date(value);
      const dateAfter = new Date(date)
      return dateBefore < dateAfter
    }
  },
  params: ['date'],
  message: '{_field_} debe ser menor a {date}'
});
extend('after_date', {
  validate(value, {date}) {
    if (value && date) {
      const dateBefore = new Date(value);
      const dateAfter = new Date(date)
      return dateBefore > dateAfter
    }
  },
  params: ['date'],
  message: '{_field_} debe ser mayor a {date}'
});

localize('es', { messages: es.messages })
localize('es')
